import { createSelector } from '@reduxjs/toolkit';

import {
  CASHIER_CONFIGURATION_FEATURE_KEY,
  CashierConfiguration,
} from './cashierConfiguration.slice';

export const selectCashierConfiguration = (
  rootState: any,
): CashierConfiguration => rootState[CASHIER_CONFIGURATION_FEATURE_KEY];

export const selectActiveType = createSelector(
  selectCashierConfiguration,
  (s) => s.activeType,
);

export const selectNotifyCustomerAboutPaymentResult = createSelector(
  selectCashierConfiguration,
  (s) => s.notifyCustomerAboutPaymentResult,
);
